window._ = require('lodash');
_.any = _.some;
window.jQuery = window.$ = require('jquery');
window.Backbone = require('backbone');
window.bowser = require('bowser');
window.StackTrace = require('stacktrace-js');
import {
    initTrackingAgent,
    trackPageLoaded,
} from '@edreamsodigeo/frontend-tracking-agent';
import {
    init as initCMP,
    isAllowed,
    createStorageClient,
} from '@edreamsodigeo/frontend-cmp-client';

(function(window, $, BB, loadedCallbackName, bowser) {
    'use strict';

    /** @namespace Odigeo */
    /**  Holds visible functionality of the framework */
    var Odigeo = window.Odigeo = window.Odigeo || {};
    var scrollUtils = require('./modules/scroll.utils');
    var templatesManager = require('./modules/templates_manager');
    var storageUtils = require('./modules/storage_utils');

    /**
     @function
     @public
     @param {Object} options
     @param {Object} options.settings User-defined settings which would override {@link Odigeo.Settings}.
     @param {Object} options.router Options required for {@link Odigeo.Router}.
     @param {Object} options.router.routes list of routes for {@link Odigeo.Router}.
     @param {Object} options.router.handlers list of route handlers for {@link Odigeo.Router}.
     @param {Function} options.router.onStart callback.
     @description Launches the app with specified options
     */
    Odigeo.start = function(options = {router:{}}) {
        // activate debuging mode when it is running on localhost
        const isLocalHost = location.hostname == 'localhost';
        // Creating static objects
        if (['AR', 'AU', 'CA', 'CL', 'CO', 'HK', 'ID', 'IN', 'MX', 'NZ', 'PE', 'PH', 'SG', 'TH', 'ZA']
            .includes(Odigeo.SessionScope.website) && Odigeo.AB.isCmpNotVisible) {
            window.didomiConfig = window.didomiConfig || {};
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiConfig.notice = {enable: false};
            window.didomiOnReady.push(function(Didomi) {
                if (Didomi.shouldConsentBeCollected()) {
                    Didomi.setUserAgreeToAll();
                }
            });
        }
        initCMP(Odigeo.SessionScope.brandNewNomenclature, Odigeo.SessionScope.lang, isLocalHost);
        const keyCheckerFn = (storage, key) => {
            return isAllowed(storage, key);
        };
        Odigeo.Storage = new Odigeo.StorageClass('local', keyCheckerFn.bind(this, 'localStorage'));
        Odigeo.Session = new Odigeo.StorageClass('session', keyCheckerFn.bind(this, 'sessionStorage'));

        Odigeo.PageStorage = new Odigeo.StorageClass('page');
        Odigeo.Templates = templatesManager;

        // options.settings
        Odigeo.Settings.bulkSet(options.settings);
        const configParametersTrackingAgent = {
            googleAnalytics: {
                endpoint: {
                    defaultCustomDimensions: Odigeo.Settings.property('trackingServiceUrlFormatter')('ua/customDimensions'),
                    pageCustomDimensions: null,
                },
                selfReferrals: Odigeo.SessionScope.selfReferrals,
                ga4GroupId: Odigeo.SessionScope.ga4GroupId,
            },
            datamesh: {
                context: '/frontend-home',
            },
            generic: {
                visitID: Odigeo.SessionScope.visitId,
                storageClient: createStorageClient(
                    Odigeo.SessionScope.brand,
                    Odigeo.SessionScope.locale
                ),
                isNativeInterface: Odigeo.SessionScope.isNativeInterface,
                dapiSessionId: undefined,
                locale: Odigeo.SessionScope.locale,
                flow: Odigeo.SessionScope.flow,
                device: Odigeo.Device.navigator.isIOSWebView ? 'IOS_' : 'ANDROID_',
                brand: Odigeo.SessionScope.brand,
                website: Odigeo.SessionScope.website,
                abs: [{
                    name: 'QUALTRICS_TMS',
                    value: Odigeo.AB.getQualtricsTms,
                }, {
                    name: 'TMS_RECOVERY',
                    value: Odigeo.AB.getTmsRecovery,
                }],
            },
        };
        initTrackingAgent(configParametersTrackingAgent);
        Odigeo.bind('routeChange', () => trackPageLoaded());

        createRouter(options.router.routes, options.router.routeMatches, options.router.handlers, options.router.appChangePages);

        placeAnchorHooks();
        bindHideShowListeners();

        // options.root
        var rootDOMObject = options.root;
        if (!rootDOMObject) {
            rootDOMObject = $('body');
        }

        if (_.has(options, 'onBeforeWidgetLoading') && _.isFunction(options.onBeforeWidgetLoading)) {
            options.onBeforeWidgetLoading();
        }

        // TODO: NEED TO PLACE LOADING WIDGETS AFTER ONSTART
        loadChildWidgets(rootDOMObject);

        if (_.has(options, 'onStart') && _.isFunction(options.onStart)) {
            options.onStart();
        }

        if (_.isFunction(window[loadedCallbackName])) {
            window[loadedCallbackName]();
        }

        scrollUtils.startScrollListener();

        Odigeo.Templates.init();

        // Event to handle grafana metrics
        if (Odigeo.Device.navigator.isTouchable()) {
            window.addEventListener('blur', function() {
                Odigeo.Session.set('disableGrafana', true);
            });
        }

        window.onoffline = function() {
            Odigeo.Session.set('disableGrafana', true);
        };
    };

    /**
     Creates {@link Odigeo.Router}
     @memberOf Odigeo
     @param {Object} routes list of routes for {@link Odigeo.Router}.
     @param {Object} routeMatches - A map of the regexp (value) that will match a given routeName (key)
     @param {Object} handlers list of route handlers for {@link Odigeo.Router}.
     @param {Object} appChangePages - An object with the pages that will imply an app change (one nested obj per app).
     @private
     */
    var createRouter = function(routes, routeMatches, handlers, appChangePages) {
        routes = routes || {};
        routeMatches = routeMatches || {};
        handlers = handlers || {};
        handlers.error = handlers.error || function() {
        };
        appChangePages = appChangePages || {};

        Odigeo.Router = new Odigeo.RouterClass({routes: routes, routeMatches: routeMatches, handlers: handlers, appChangePages: appChangePages});
    };

    /**
     Adds listeners to each 'a' tag with 'data-href' attribute on a page - all the clicks should bw delegated to {@link Odigeo.Router}
     @memberOf Odigeo
     @private
     */
    var placeAnchorHooks = function() {
        $('body').on(Odigeo.Events.tap, '[data-href]', function() {
            Odigeo.Router.navigate($(this).attr('data-href'));
        });
    };

    /**
     Loads widget definitions for each visible widget placeholder found
     @memberOf Odigeo
     @param {Object} DOMObject Base object to look for widgets.
     @private
     */
    var loadChildWidgets = function(DOMObject) {
        var widgets = $(DOMObject).find('[data-widget][data-cache=true],[data-widget]:visible').filter('[data-js!=false]');
        var lazyViewWidgets = $(DOMObject).find('[data-js=false][data-loaded!=true]');

        widgets.each(function(idx, value) {
            var $value = $(value);
            var widgetId = $value.attr('data-id');
            var widgetName = $value.attr('data-widget');

            loadChildWidget(widgetId, widgetName, true);
        });

        lazyViewWidgets.each(function(idx, value) {
            var $value = $(value);
            var widgetId = $value.attr('data-id');
            var widgetName = $value.attr('data-viewwidget');
            Odigeo.requireWidget(widgetId, widgetName);
        });
    };

    /**
     Loads widget definition and creates its instance
     @memberOf Odigeo
     @param {string} widgetId Data-id property value of a widget instance.
     @param {string} widgetName Name of the widget to be loaded.
     @param {Function} additionalCallback Function to be executed when the widget already loaded.
     @param {Function} errCallback Callback to execute when widget construction fails.

     @private
     */
    var loadChildWidget = function(widgetId, widgetName, additionalCallback, errCallback) {
        var constructWidget = function(widgetDef) {
            var isWidgetInCache = !!widgets[widgetId];
            var hasError = !isWidgetInCache && widgetDef === null;

            if (!hasError) {
                if (!isWidgetInCache) {
                    addWidgetToCache(widgetId, widgetName, widgetDef);
                }
                if (_.isFunction(additionalCallback)) {
                    additionalCallback.call(this, widgets[widgetId]);
                }
            } else {
                handleError('No widget definition for ' + widgetName + '. Did you forget to call Odigeo.defineWidget?', errCallback);
            }
        };

        getWidget(widgetId, widgetName, constructWidget);
    };

    function addWidgetToCache(widgetId, widgetName, WidgetDef) {
        var widgetInstance = new WidgetDef(widgetName, widgetId);
        widgets[widgetId] = widgetInstance;
        widgetInstance.construct();
    }

    function handleError(errMsg, errCallback) {
        if (_.isFunction(errCallback)) {
            errCallback(errMsg);
        } else {
            throw new Error(errMsg);
        }
    }

    /**
     Binds hide/show listeners to each widget placeholder. This listener should load widget definition and create
     an instance of a widget as soon as the placeholder would become visible.
     @memberOf Odigeo
     @private
     */
    var bindHideShowListeners = function() {
        $('[data-widget]').on('show', function(evt) {
            if (evt.currentTarget === evt.target) {
                var widgetID = $(this).attr('data-id');
                if (!widgets[widgetID]) {
                    var widgetName = $(this).attr('data-widget');

                    var widgetIDs = [];
                    var widgetNames = [];

                    $(this).find('[data-widget][data-cache=true],[data-widget]')
                        .filter('[data-loaded=true]').sort(function(widget1, widget2) {
                            // sorting as deepest first
                            return $(widget2).parents().length - $(widget1).parents().length;
                        }).each(function(i, v) {
                            widgetIDs.push($(v).attr('data-id'));
                            widgetNames.push($(v).attr('data-widget'));
                        });
                    widgetIDs.push(widgetID);
                    widgetNames.push(widgetName);

                    $.each(widgetIDs, function(idx) {
                        Odigeo.requireWidget(widgetIDs[idx], widgetNames[idx]);
                    });
                }
            }
        });
    };

    /**
     Loads widget script and html
     @memberOf Odigeo
     @param {string} widgetId identifier of the widget.
     @param {string} widgetName name of the widget.
     @param {Function} callback Function to be executed when the widget definition would be loaded.
     @private
     */
    var loadWidget = function(widgetId, widgetName, callback) {
        var $widget = $('[data-id=' + widgetId + ']');
        var url = getWidgetURL(widgetId, widgetName);
        $.ajax({
            url: url,
            dataType: 'html',
            complete: function() {
            },
            success: function(html) {
                $widget.html(html).attr('data-loaded', 'true');
                if (typeof callback === 'function') {
                    callback(html);
                }
            },
            error: function() {
                throw new Error('loadWidget cannot get widget html by URL: ' + url);
            },
        });
    };

    /**
     Stores instances of {@link Odigeo.Widget} and its subclasses
     @memberOf Odigeo
     @private
     */
    var widgets = {};

    /**
     Stores instances of {@link Odigeo.WidgeStatus} - registered Widgets
     @memberOf Odigeo
     @private
     */
    var registeredWidgets = {};

    /**
     Loads widget definition if necessary and passes it to callback function
     @memberOf Odigeo
     @param {string} widgetID Widget instance name.
     @param {string} widgetName Widget definition name.
     @param {Function} callback Function to be executed when the widget definition would be loaded.
     @private
     */
    var getWidget = function(widgetID, widgetName, callback) {
        var widgetStatus = registeredWidgets[widgetName];
        var $widget = $('[data-id=' + widgetID + ']');

        if (!widgetStatus) {
            widgetStatus = Odigeo.registerWidget(widgetName);
        }

        // if Widget class and template are already loaded
        // TODO: all loaded widget instances should be contained by widgetStatus
        if (widgetStatus.loaded && $widget.attr('data-loaded') === 'true') {
            // Construct instance
            callback(widgetStatus.widgetDef);
            return;
        }

        widgetStatus.loading = true;

        if ($widget.attr('data-template') === 'true') {
            Odigeo.Templates.getWidgetTemplate(widgetName).done(function(response) {
                if (_.isObject(response)) {
                    $widget.attr('data-loaded', 'true');
                    callback(widgetStatus.widgetDef);
                } else {
                    throw new Error('loadWidget template cannot get widget id: ' + widgetID);
                }
            });
        } else {
            loadWidget(widgetID, widgetName);
        }
    };

    /**
     Gets the list of registered widgets names
     @memberOf Odigeo
     @private
     @return {array}
     */
    var getRegisteredWidgets = function() {
        return _.map(registeredWidgets, function(status, widgetName) {
            return widgetName;
        });
    };
    /**
     Returns the list of registered widgets names
     @memberOf Odigeo
     @return {array}
     */
    Odigeo.getRegisteredWidgets = getRegisteredWidgets;

    /**
     Returns the widgets instances list group by its name
     @memberOf Odigeo
     @public
     @return {array}
     */
    Odigeo.getRegisteredWidgetsByName = function() {
        return _.groupBy(widgets, function(w) {
            return w.name;
        });
    };

    /**
     Gets widget URL based on app settings
     @memberOf Odigeo
     @param {string} widgetID Widget instance name.
     @param {string} widgetName Widget definition name.
     @return {string}
     @private
     */
    var getWidgetURL = function(widgetID, widgetName) {
        var $widgets = $('[data-id=' + widgetID + ']');
        var js = $widgets.attr('data-js');
        var dataParams = $widgets.attr('data-params');

        dataParams = dataParams ? '&' + dataParams : '';
        js = js ? '&js=' + js : '';
        return Odigeo.Settings.property('widgetUrlFormatter')(widgetID, widgetName) +
            js +
            dataParams +
            '&exclude=' + getRegisteredWidgets().join(',');
    };

    /**
     Returns widget instance by its id
     @param {string} widgetID widget instance id.
     @return {Odigeo.Widget} Appropriate widget instance.
     @public
     */
    Odigeo.getWidgetByID = function(widgetID) {
        if (widgets[widgetID]) {
            return widgets[widgetID];
        }
        return false;
    };

    /**
     Registers widget source
     @param {string} widgetName widget name.
     @param {string} widgetSrc widget definition source.
     @return {Odigeo.WidgetStatus} widget status descriptor.
     @public
     */
    Odigeo.registerWidget = function(widgetName, widgetSrc) {
        var widgetStatus = registeredWidgets[widgetName];
        if (widgetStatus) {
            return widgetStatus;
        }
        registeredWidgets[widgetName] = new WidgetStatus(widgetSrc);
        return registeredWidgets[widgetName];
    };

    /**
     Defines widget class and calls registered callbacks if necessary
     @param {string} widgetName Widget name.
     @param {Object} widgetDef Widget definition.
     @public
     */
    Odigeo.defineWidget = function(widgetName, widgetDef) {
        if (!registeredWidgets[widgetName]) {
            registeredWidgets[widgetName] = new WidgetStatus();
        }

        registeredWidgets[widgetName].loading = false;
        registeredWidgets[widgetName].loaded = true;
        registeredWidgets[widgetName].widgetDef = widgetDef;
    };

    /**
     Should invoke widget loading & call callback function as soon as widget would be available
     @param {string} widgetID Widget instance id.
     @param {string} widgetName Widget name.
     @param {Function} callback Callback to execute when widget definition is ready.
     @param {Function} errCallback Callback to execute when widget construction fails.
     @public
     */
    Odigeo.requireWidget = function(widgetID, widgetName, callback, errCallback) {
        loadChildWidget(widgetID, widgetName, callback, errCallback);
    };

    /**
     * Autoload function to require widgets in a one-liner.
     * @param {object} widgets Object containing name of the widget and id as properties.
     * @return {object}
     * @public
     * @deprecated use autoloadWidgetsAsync instead
     */
    Odigeo.autoloadWidgets = function(widgets) {
        // Widgets Autoload (with lazy initialization pattern)
        return _.reduce(widgets, function(memo, val, key) {
            memo[key] = function() {
                var isWidgetLoad = false;
                var args = _.toArray(arguments);
                var id = val[0].replace(/\$\{(\d+)\}/g, function(m, index) {
                    return args[index];
                });
                var alias = key + '(' + args.join(',') + ')';
                Odigeo.requireWidget(id, val[1], function(widget) {
                    isWidgetLoad = true;
                    memo[alias] = function() {
                        return widget;
                    };
                });
                return isWidgetLoad ? memo[alias]() : {
                    execute: function() {
                    },
                };
            };
            return memo;
        }, {});
    };

    /**
     *
     * Autoload function to require widgets in a one-liner.
     *
     * Contract:
     * - Returns an object whose keys are aliases to widgets and values are pointers to functions.
     * - These functions will return proxy objects of widgets.
     * - These proxies have an "execute" method, it'll call the widget "execute" method asynchronously once the widget is loaded.
     * - Any argument provided to the "execute" method of the proxy will be forwarded to the "execute" method of the widget.
     * - The return value of the proxy "execute" method will be a promise:
     *      - If the widget loads succesfully, the promise will be fulfilled with the value returned by the widget "execute" method.
     *      - If the widget fails to be loaded, the returned promise will be rejected.
     * - These proxies ONLY expose the "execute" method of the widget (consider using requireWidget directly
     *   if you're interested in something different).
     * - No lazy initialization pattern or cache needed (we rely on the one provided by requireWidget).
     *
     * @param {object} widgets Each key will be a new key in the returned object and can be think of as an "alias"
     *        to get to the proxy object of a widget.
     * The values must be arrays, being the first element the id of the widget and the second, the name.
     * @return {object} the keys will be the aliases, the values will be pointers to functions that return proxy objects.
     * @public
     */
    Odigeo.autoloadWidgetsAsync = function(widgets) {
        return _.reduce(widgets, function(memo, val, key) {
            memo[key] = function() {
                var dfr = $.Deferred();
                var promise = dfr.promise();

                Odigeo.requireWidget(val[0], val[1], dfr.resolve, dfr.reject);
                var widgetFunction = function(type, args) {
                    return promise.then(function(widget) {
                        return widget[type].apply(widget, args);
                    });
                };
                return {
                    execute: function() {
                        return widgetFunction('execute', arguments);
                    },
                    get: function() {
                        return widgetFunction('get', arguments);
                    },
                };
            };
            return memo;
        }, {});
    };

    /**
     Loads a set of widgets and call a callback at the end
     @args
     {string} widgetName Widget name.
     {Function} callback Callback to execute when widget definition is ready.
     @public
     */
    Odigeo.requireWidgets = function() {
        var args = _.toArray(arguments);
        var callback = (args.length % 2) ? args.pop() : Function;
        var widgetId;
        var widgetName;
        var widgetRefs = [];

        if (callback) {
            callback = _.wrap(callback, function(func) {
                func.apply(this, _.map(widgetRefs, function(ref) {
                    return widgets[ref];
                }));
            });
        }

        while (args.length > 2) {
            widgetName = args.pop();
            widgetId = args.pop();
            widgetRefs.unshift(widgetId);
            callback = _.wrap(callback, _.partial(loadChildWidget, widgetId, widgetName, callback));
        }

        widgetRefs.unshift(args[0]);
        widgetId = args.shift();
        loadChildWidget(widgetId, args.shift(), callback);
    };

    Odigeo.addScrollListener = function(options) {
        scrollUtils.addScrollListener(options);
    };

    Odigeo.removeScrollListener = function(listenerName) {
        scrollUtils.removeScrollListener(listenerName);
    };

    Odigeo.getRelativeScreenPosition = function($element) {
        return scrollUtils.getRelativeScreenPosition($element);
    };

    Odigeo.calculateScroll = function() {
        return scrollUtils.calculateScroll();
    };
    /**
     Stores custom options for {@link Odigeo.Widget} or its subclasses instances
     @memberOf Odigeo
     @private
     */
    var widgetOptions = {};

    /**
     * Parses a given object
     * @param {object} options to parse
     * @type {function}
     * @return {object}
     * @memberOf Odigeo
     * @public
     */
    var parseOptions = function(options) {
        return _.chain(options).map(function(val, key) {
            var parsedOption = Array(key);
            try {
                parsedOption.push(JSON.parse(val));
            } catch (e) {
                parsedOption.push(val);
            }
            return parsedOption;
        }).fromPairs().value();
    };

    /**
     * @see {parseOptions}
     */
    Odigeo.parseOptions = parseOptions;

    /**
     Defines widget instance custom options, adding them to possibly previously defined options.
     @param {string} widgetID Widget instance id.
     @param {Object} options Object containing custom options for appropriate widget instance.
     @public
     */
    Odigeo.setOptionsByID = function(widgetID, options) {
        widgetOptions[widgetID] = widgetOptions[widgetID] || {};
        _.extend(widgetOptions[widgetID], options); // TODO parseOptions(options)
    };

    /**
     Reconstructing widget, make new clean instance for unit tests reasons
     @param {string} widgetID Widget instance id.
     @param {string} widgetName Widget name.
     @public
     */
    Odigeo.reConstructWidget = function(widgetID, widgetName) {
        var compInst = new registeredWidgets[widgetName].widgetDef(widgetName, widgetID); // eslint-disable-line new-cap
        widgets[widgetID] = compInst;
        compInst.construct();
    };

    /**
     Returns custom instance options by widget instance ID
     @memberOf Odigeo
     @param {string} widgetID Widget instance id.
     @return {Object} Object containing custom options for appropriate widget instance.
     @private
     */
    var getOptionsByID = function(widgetID) {
        return widgetOptions[widgetID] || {};
    };

    /**
     Implements basic Events dispatching logic.
     @class
     */
    var isTouchable = function() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    };

    Odigeo.Events = BB.Events;
    _.extend(Odigeo.Events, /** @lends Odigeo.Events# */ {
        click: 'click',
        tap: 'tap',
        touchstart: window.PointerEvent && isTouchable() ? 'pointerdown' : 'movestart',
        // mousedown touchstart',
        touchmove: window.PointerEvent && isTouchable() ? 'pointermove' : 'move',
        // 'mousemove touchmove',
        touchend: window.PointerEvent && isTouchable() ? 'pointerup' : 'moveend',
        // 'mouseup touchend',
        touchcancel: window.PointerEvent && isTouchable() ? 'pointercancel' : 'moveend',
        input: 'textchange',
        focus: 'focus',
        blur: 'blur',
        keyup: 'keyup',
        keydown: 'keydown',
        swipe: 'swipe',
        swipeRight: 'swiperight',
        swipeLeft: 'swipeleft',
        swipeUp: 'swipeup',
        swipeDown: 'swipedown',
        change: 'change',
        mouseover: 'mouseover',
        mouseout: 'mouseout',
        mousedown: 'mousedown',
        mouseLeave: 'mouseleave',
        mouseEnter: 'mouseenter',
        transitionEnd: 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
        animationEnd: 'animationend animationend webkitAnimationEnd oanimationend MSAnimationEnd',
        scroll: 'scroll',
        paste: 'paste',
        keys: {
            KEY_BACKSPACE: 8,
            KEY_TAB: 9,
            KEY_RETURN: 13,
            KEY_ESC: 27,
            KEY_LEFT: 37,
            KEY_UP: 38,
            KEY_RIGHT: 39,
            KEY_DOWN: 40,
            KEY_DELETE: 46,
            KEY_HOME: 36,
            KEY_END: 35,
            KEY_PAGEUP: 33,
            KEY_PAGEDOWN: 34,
            KEY_INSERT: 45,
        },
    });

    /**
     Emit fake native events. E.G. fake:blur
     @class
     @static
     */
    Odigeo.Events.fake = _.extend({}, BB.Events);

    /**
     Binds/unbinds global events and view events when the route handler is changes.
     @class
     @static
     */
    Odigeo.Events.EventControllerClass = function() {
        // Events that exists along the lifetime of the app
        this.globalEvents = {};

        // Events the are required just in the current view. They will be unbound after moving out of the page
        this.viewEvents = {};

        // Handlers implementation
        this.eventHandlers = {};

        // Keep the previous view events with the purpose of unbound them when the page dissapear
        this.previousViewEvents = {};

        // Bind/unbind the events required for the page
        this.execute = function() {
            // Unbind previous view events
            _.each(this.previousViewEvents, function(func, key) {
                Odigeo.off(key);
            });
            this.previousViewEvents = {};

            _.each(['global', 'view'], (eventsType) => {
                // Bind eventsType events
                _.each(this[eventsType + 'Events'], (func, key) => {
                    Odigeo.off(key);
                    if (!_.isFunction(this.eventHandlers[func])) {
                        throw new Error('Handler <' + func + '> for ' + eventsType + ' event "' + key + '" is not defined.');
                    }
                    Odigeo.on(key, this.eventHandlers[func], this.eventHandlers);

                    if (eventsType === 'view') {
                        this.previousViewEvents[key] = func;
                    }
                });
            });

            return this;
        };

        // Empty globalEvents and viewEvents for a proper initialization in the routehandler
        // if it is not extended the eventcontroller
        this.reset = function() {
            this.globalEvents = {};
            this.viewEvents = {};
            this.eventHandlers = {};
        };
    };

    /**
     Provide an enum Object
     @param {array} values
     @class
     */
    Odigeo.Enum = function(values) {
        if (_.isArray(values)) {
            _.forEach(values, _.bind(function(value) {
                this[value] = value;
            }, this));
        }
    };

    /**
     Handles cross-browser history management, based on URL fragments. If the
     browser does not support 'onhashchange', falls back to polling.
     @class
     */
    Odigeo.HistoryClass = BB.History.extend({

        start: function(options) {
            options = options || {};
            this._hashChange = options.hashChange !== false;
            this._pushState = !!options.pushState;
            BB.History.prototype.start.call(this, options);
        },

        navigate: function(route, app, options) {
            var navOptions = _.defaults({}, options, {trigger: true});
            var fragment = this.isPushState() ? app + route : route;
            BB.History.prototype.navigate.call(this, fragment, navOptions);
        },

        isPushState: function() {
            return this._pushState;
        },

        isHashChange: function() {
            return this._hashChange;
        },

        /**
         Returns page name string from the given fragment. If the fragment is omitted, defaults to BB's getFragment.
         @param {string} fragment
         @return {string} page name
         */
        getPageNameFromFragment: function(fragment) {
            var fr = fragment || this.getFragment() || Odigeo.History?.location?.pathname || '';
            var fragmentUntilHash = new RegExp(/.*#\/?/); // hashChange compatibility. Remove whenever we are 100% pushState
            var pageRegExp = new RegExp(/([^/]*(?:\/[^/]*)*)\//);
            var appRegExp = new RegExp(/^\/?(?:frontend-home\/)?(?:(?:dp|secure|flights)\/)?/);

            var isFragmentUntilHash = fr.match(fragmentUntilHash);
            var pageMatch = fr.replace(isFragmentUntilHash ? fragmentUntilHash : appRegExp, '').match(pageRegExp);
            var pageName = pageMatch ? pageMatch[1].replace(/\/$/, '') : 'home';
            if (!isFragmentUntilHash) {
                // Caveat: 'flights' can be the app, the page name, and part of the pageName as in mobile 'flights/departure0'...
                pageName = pageName.match(/(?:departure\d|destination\d|passengers|dates|edit)$/) ?
                    'flights/' + pageName.replace(/flights\//, '') :
                    pageName;
            }
            return pageName;
        },
    });

    /**
     Instance of {@link Odigeo.HistoryClass}
     @static
     @type {Odigeo.HistoryClass}
     */
    Odigeo.History = (Odigeo.History || new Odigeo.HistoryClass());

    /**
     Takes care of all global application settings
     @static
     @type {Object}
     */
    Odigeo.Settings = {};

    _.extend(Odigeo.Settings, {
        /**
         Contains name-value pairs of all application settings
         @name Odigeo.Settings#options
         @type Object
         @private
         */
        options: { /** @lends Odigeo.Settings#options */
            /**
             * Pathnames for secure routes and non secure routes.
             */
            pathNames: {
                homeflights: '/',
                dp: '/dp/',
                flights: '/flights/',
                secure: '/secure/',
                supportarea: '/support-area/',
                cms: '/s/',
            },
            /**
             Used by default Service URL formatter: prefix + service_name
             @memberOf Odigeo.Settings.prototype
             @default ''
             @type String
             */
            serviceUrlPrefix: '/service/flow/',
            geoServiceUrlPrefix: '/service/geo/',
            coreServiceUrlPrefix: '/service/coredata/',
            serviceUsersPrefix: '/service/users/',
            serviceDestinationsPrefix: '/service/',
            dataSearchServiceUrlPrefix: '/service/datasearch/',
            collectionMethodPrefix: '/service/collectionmethod/',
            inspirationalServiceUrlPrefix: '/service/inspirational/',
            trackingToolService: '/service/trackingsystem/',
            templatesUrlPrefix: '/service/templates/',
            trackingServiceUrlPrefix: '/service/tracking/',
            travelAudiencePrefix: '/service/advertisement/travelaudience/',
            metricServiceUrlPrefix: '/service/metrics/',
            searchServiceUrlPrefix: '/service/',
            suggestionServiceUrlPrefix: '/service/suggestions/',
            membershipServicePrefix: '/service/membership/',
            emailServiceUrlPrefix: '/service/emails/',
            urlSearchServiceUrlPrefix: '/service/urlsearch/',
            carsServiceUrlPrefix: '/service/cars/',
            countryLinksServiceUrlPrefix: '/service/countrylinks/',
            tagManagementUrlPrefix: '/service/tms/',
            /**
             Default service URL formatter: prefix + service_name
             @memberOf Odigeo.Settings.prototype
             @param {string} serviceName Name of the service.
             @return {string} Widget URL.
             */
            serviceUrlFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('serviceUrlPrefix') + serviceName;
            },
            geoServiceUrlFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('geoServiceUrlPrefix') + serviceName;
            },
            trackingToolServiceFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('trackingToolService') + serviceName;
            },
            coreUrlFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('coreServiceUrlPrefix') + serviceName;
            },
            serviceUsersFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('serviceUsersPrefix') + serviceName;
            },
            serviceDestinationsFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('serviceDestinationsPrefix') + serviceName;
            },
            carsServiceFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('carsServiceUrlPrefix') + serviceName;
            },
            countryLinksServiceUrlFormatter: function() {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('countryLinksServiceUrlPrefix');
            },
            inspirationalServiceUrlFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('inspirationalServiceUrlPrefix') + serviceName;
            },
            templatesMethodFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('templatesUrlPrefix') + serviceName;
            },
            trackingServiceUrlFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('trackingServiceUrlPrefix') + serviceName;
            },
            metricServiceUrlFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('metricServiceUrlPrefix') + serviceName;
            },
            urlSearchServiceUrlFormater: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('urlSearchServiceUrlPrefix') + serviceName;
            },
            tagManagementUrlFormatter: function(serviceName) {
                return Odigeo.Settings.property('appContext') + Odigeo.Settings.property('tagManagementUrlPrefix') + serviceName;
            },
            /**
             Used by default Widget URL formatter: prefix + widget_name + postfix
             @memberOf Odigeo.Settings.prototype
             @default ''
             @type String
             */
            widgetUrlPrefix: '/widget/',
            /**
             Used by default Widget URL formatter: prefix + widget_name + postfix
             @memberOf Odigeo.Settings.prototype
             @default '.js'
             @type String
             */
            widgetUrlPostfix: '',
            /**
             @memberOf Odigeo.Settings.prototype
             Default Widget URL formatter: prefix + widget_name + postfix
             @param {string} widgetID Widget instance name.
             @param {string} widgetName Widget class name.
             @return {string} Widget URL.
             */
            widgetUrlFormatter: function(widgetID, widgetName) {
                return Odigeo.Settings.property('appContext') +
                    Odigeo.Settings.property('widgetUrlPrefix') +
                    Odigeo.Settings.property('widgetUrlPostfix') + widgetName + '?id=' + widgetID;
            },
            /**
             Default Widget URL formatter: prefix + widget_name + widget_part
             @param {string} widgetName Widget class name.
             @param {string} widgetPart Widget part name.
             @param {Object} params to the url.
             @memberOf Odigeo.Settings.prototype
             @return {string} Widget URL
             */
            widgetPartUrlFormatter: function(widgetName, widgetPart, params) {
                var paramsFormated = $.param(params || {});

                if (!_.isEmpty(paramsFormated)) {
                    paramsFormated = '?' + paramsFormated;
                }

                return Odigeo.Settings.property('appContext') +
                    Odigeo.Settings.property('widgetUrlPrefix') +
                    Odigeo.Settings.property('widgetUrlPostfix') +
                    widgetName + '/' + widgetPart + paramsFormated;
            },
            /**
             Used by checkLazyImages
             @memberOf Odigeo.Settings.prototype
             @default 0
             @type number
             */
            lazyThreshold: 0,
            /**
             Used by check Odigeo.Router.go to check if location.pathname contains this path.
             @memberOf Odigeo.Settings.prototype
             @type String
             */
            pathApiSearchplugin: 'api/searchplugin',
        },
    });

    _.extend(Odigeo.Settings, /** @lends Odigeo.Settings */ {
        /**
         Gives a way to set a number of options at a time
         @param {object} options An object containing properties which would override original ones.
         */
        bulkSet: function(options) {
            _.extend(this.options, options);
        },
        /**
         Gets property value by name
         @param {string} propName
         @return {property}
         */
        getProperty: function(propName) {
            return this.options[propName];
        },
        /**
         Sets a new value for one property with
         @param {string} propName
         @param {Object} value new value of the property.
         */
        setProperty: function(propName, value) {
            this.options[propName] = value;
        },
        /**
         Gets or sets property value (depending on whether the 'value' parameter was passed or not)
         @param {string} propName
         @param {Object} [value] new value of the property.
         @return {undefined|property}
         */
        property: function(propName, value) {
            if (value === undefined) {
                return this.getProperty(propName);
            } else {
                this.setProperty(propName, value);
            }
        },
    });

    /**
     Instance of {@link Odigeo.StorageClass}
     @static
     @private
     @type {Odigeo.StorageClass}
     */
    Odigeo.Session = null;

    /**
     Instance of {@link Odigeo.StorageClass}
     @static
     @private
     @type {Odigeo.StorageClass}
     */
    Odigeo.Storage = null;

    /** @namespace Odigeo.StorageClass */
    /**
     Provides localStorage caching API
     @param {string} type
     @param {function} type
     @class
     @static
     */
    Odigeo.StorageClass = function(type, consentCheckerFunction) {
        /**
         Local reference to the localStorage
         @type {Object}
         */
        this.storage = null;

        type = type || 'local';
        this.type = type;
        consentCheckerFunction = consentCheckerFunction || _.constant(true);
        this.consentCheckerFunction = consentCheckerFunction;

        try {
            this.storage = window[type + 'Storage'];
            this.storage.setItem('onetwo', 'onetwo');
            this.storage.removeItem('onetwo');
        } catch (e) {
            // Fallback storage.
            // In the case that the browser is using a 'Private Mode' that doesn't allow local or session storage
            this.storage = (function() {
                var fallbackStorage = {};

                return {
                    getItem: function(key) {
                        return fallbackStorage[key] || null;
                    },

                    setItem: function(key, value) {
                        fallbackStorage[key] = String(value);
                    },

                    removeItem: function(key) {
                        delete fallbackStorage[key];
                    },

                    clear: function() {
                        fallbackStorage = {};
                    },

                    getAllKeys: function() {
                        return _.keys(fallbackStorage);
                    },
                };
            }());
        }
    };

    _.extend(Odigeo.StorageClass.prototype, /** @lends Odigeo.StorageClass.prototype */ {
        /**
         Returns a value stored in cache under appropriate key
         @param {string} key
         @return {string}
         */
        get: function(key) {
            var result = null;
            try {
                result = this.consentCheckerFunction(key) ? this.storage.getItem(key): null;
            } catch (e) {
                result = null;
            }
            return result;
        },
        /**
         Sets a value stored in cache under appropriate key
         @param {string} key
         @param {string} value
         @return {Boolean} success indicator.
         */
        set: function(key, value) {
            var result = false;
            try {
                if (this.consentCheckerFunction(key)) {
                    this.storage.setItem(key, value);
                    result = true;
                }
            } catch (e) {
                if (e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.name === 'QuotaExceededError') {
                    Odigeo.trigger('fullStorage');
                }
            }

            return result;
        },

        /**
         Remove one key from the storage
         @param {string} key
         @return {Boolean} success indicator.
         */
        remove: function(key) {
            var result = true;
            try {
                this.storage.removeItem(key);
            } catch (e) {
                result = false;
            }

            return result;
        },

        /**
         Clears storage
         @return {Boolean} success indicator.
         */
        clear: function() {
            var result = true;
            try {
                this.storage.clear();
            } catch (e) {
                result = false;
            }
            return result;
        },

        /**
         Clears forced storage
         @param {array} keysForcedToBeCleared
         */
        clearForced: function(keysForcedToBeCleared) {
            var storage = this.storage;
            _.each(keysForcedToBeCleared, function(key) {
                if (!_.isNull(storage.getItem(key))) {
                    storage.removeItem(key);
                }
            });
        },

        getAllKeys: function() {
            return _.isFunction(this.storage.getAllKeys) ? this.storage.getAllKeys() : _.keys(this.storage);
        },

        /**
         Clears all storage except the properties passed as parameter
         @param {array} exceptionsList
         */
        removeAllExcept: function(exceptionsList) {
            var removeElements = _.difference(this.getAllKeys(), exceptionsList);
            _.each(removeElements, _.bind(function(key) {
                this.storage.removeItem(key);
            }, this));
        },
    });

    /**
     Instance of {@link Odigeo.RouterClass}
     @static
     @type {Odigeo.Router}
     */
    Odigeo.Router = {
        handlers: {},
    };

    var namedParam = /:([\w\d]+)/g;
    var splatParam = /\*([\w\d]+)/g;
    var escapeRegExp = /[-[\]{}()+?.,\\^$|#\s]/g;

    // _.extend(Odigeo.RouterClass.prototype, Odigeo.Events});
    /**
     Implements Routing.
     @class
     @static
     @augments Odigeo.Events
     @param {Object} routes routes has map.
     @param {Object} handlers handlers has map.
     */
    Odigeo.RouterClass = BB.Router.extend(/** @lends Odigeo.RouterClass.prototype */ {

        /**
         Contains apps with pages that change to other apps (funnel change)
         @type {Object}
         */
        appChangePages: {},

        /**
         EventController instance. Bind/unbind global and view events require for the current route
         @type {Odigeo.Events.EventControllerClass}
         */
        eventController: null,

        /**
         * Gets the current app
         * @return {*|jQuery|string}
         */
        getCurrentApp: function() {
            return $('body').data('app') || (/secure/.test(document.location.pathname) ? 'secure' : 'home');
        },

        /**
         * Check the appChangePages map to know from the currentApp we are changing the app to go to the next page
         * @param {string} page
         * @return {string}
         */
        getApp: function(page) {
            var mainPage = page === '' ? 'home' : page.replace(/\/.*/i, '');
            var currentApp = this.getCurrentApp();
            var appChange = this.appChangePages[currentApp] || {};

            return !_.isUndefined(appChange[mainPage]) ? appChange[mainPage] : currentApp;
        },

        /**
         Go to view(page) and creates URL with protocol and hash before
         @param {string} pageName - view name.
         @param {Object} options
         */
        navigate: function(pageName, options) {
            options = _.defaults(options || {}, {params: ''});
            var appPathNames = Odigeo.Settings.getProperty('pathNames');
            var currentApp = Odigeo.Utils.isWebmasterPage() ? 'wmp' : appPathNames[this.getCurrentApp()]; // Force reload when navigating from a wmp.
            var currentProtocol = location.protocol;
            var targetApp = options.preservePath ? currentApp : appPathNames[this.getApp(pageName)];
            var targetProtocol = (targetApp === 'secure' || options.isSecured) ? 'https:' : currentProtocol;
            // Probably the '' or '/' cases lack params and can use the falsy path in the ternary below.
            var targetRoute = (_.includes(['', '/', 'home'], pageName) ? '' : pageName + '/') + options.params;

            // If we are using the same protocol and the same path.. do not change complete URL
            // Also, we have to review the idea of App, because secure and DP cannot be both an app
            // being "currentApp" DP while on secure and Secure when not on DP is just a weird trick
            if (currentProtocol === targetProtocol && currentApp === targetApp) {
                Odigeo.History.navigate(targetRoute, targetApp, options);
            } else {
                // Remove utm* and gclid parameters to avoid Universal Analytics creating new sessions when the user navigates
                var hasToRemoveUtmParametersFromUrl = Odigeo.Session.get('hasToRemoveUtmParameters') === 'true';
                var search = hasToRemoveUtmParametersFromUrl ? location.search.replace(/((?:&?utm_\w+|&?gclid)=[^&#]*)/g, '') : location.search;
                Odigeo.Router.changeLocation(targetApp, targetRoute, search, options);
            }
        },

        changeLocation: function(appPath, routePath, queryString, options) {
            options = options || {};
            var fragment = appPath + (Odigeo.History.isPushState() ? routePath + queryString : queryString + '#' + routePath);
            var href = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + fragment;
            if (options.replace) {
                location.replace(href);
            } else {
                location.href = href;
            }
        },

        reload: function() {
            location.reload(true);
        },

        /**
         Manually bind a single named route to a callback.
         @param {RegExp} route route pattern.
         @param {string} name route name.
         @param {Function} callback
         @private
         */
        route: function(route, name, callback) {
            Odigeo.History = (Odigeo.History || new Odigeo.HistoryClass());

            if (!_.isRegExp(route)) {
                route = this._routeToRegExp(route);
            }

            Odigeo.History.route(route, _.bind(function(fragment) {
                var args = this._extractParameters(route, fragment);
                callback.apply(this, args);
                this.trigger.apply(this, ['route:' + name].concat(args));
            }, this));
        },

        /**
         Convert a route string into a regular expression, suitable for matching against the current location hash.
         @param {string} route route pattern.
         @return {RegExp}
         @private
         */
        _routeToRegExp: function(route) {
            route = route
                .replace(escapeRegExp, '\\$&')
                .replace(namedParam, '(.*)')
                .replace(splatParam, '(.*?)');
            return new RegExp('^' + route + '$');
        },

        /**
         Initializes routers, creates handlers and proxy handlers to track {@link Odigeo.RouterClass#mostRecentCalled}
         @param {object} options
         @private
         */
        initialize: function(options) {
            var $this = this;

            /**
             Contains all routes definitions
             @type {Object}
             */
            this.handlers = options.handlers || {};

            /**
             * Contains sandboxes for every handler to allow persist data among several executions og a handler.
             @type {Object}
             */
            this.handlerSandboxes = {};

            /**
             Saves the latest route dispatched
             @type Object
             @private
             */
            this.mostRecentCalled = null;

            /**
             Contains apps with pages that change to other apps (funnel change)
             @type {Object}
             */
            this.appChangePages = options.appChangePages || {};

            // Create the instance of event controller
            this.eventController = new Odigeo.Events.EventControllerClass();

            Odigeo.History = (Odigeo.History || new Odigeo.HistoryClass());

            // adding rest routes
            var routeHandlerWrapper = function(routeDef, routeName) {
                var proxyCallback = function() {
                    var callback = $this.handlers[routeName];
                    var called;

                    $this.handlerSandboxes[routeName] = $this.handlerSandboxes[routeName] || {};

                    called = {
                        name: routeName,
                        args: arguments,
                    };

                    Odigeo.trigger('routeChange', {from: $this.mostRecentCalled, to: called});

                    if (callback) {
                        // Reset the global events and viewEvents
                        $this.eventController.reset();
                        callback.apply($this.handlerSandboxes[routeName], arguments);
                    }

                    $this.mostRecentCalled = {
                        name: routeName,
                        args: arguments,
                    };
                };
                $this.route(routeDef, routeName, proxyCallback);
            };

            routeHandlerWrapper(/(.*)/, 'error'); // This is the first one as it will be used by backbone as a last resort
            _.each(options.routeMatches, function(routeDef, routeName) {
                if (_.isRegExp(routeDef)) {
                    routeHandlerWrapper(routeDef, routeName);
                }
            });
            $.each(this.routes, routeHandlerWrapper);
        },

        /**
         Initiates Rounting & history listening
         @private
         */
        start: function() {
            Odigeo.History.start({pushState: false, hashChange: true});
            // subscribe scroll and 'checkLazyImages' events to repaint images on lazy load
            $(window).scroll(checkLazyImages);
            Odigeo.bind('checkLazyImages', checkLazyImages);
        },

        /**
         Binds a callback to any route
         @param {Function} callback A function to be called when any route is visited.
         */
        bindAnyRoute: function(callback) {
            this.on('all', callback);
            if (this.mostRecentCalled) {
                callback(this.mostRecentCalled.name);
            }
        },

        /**
         Returns route string by givven router event name
         @param {string} eventName
         @return {string}.
         */
        getRouteByEventName: function(eventName) {
            return eventName.replace('route:', '');
        },
    });

    /**
     Base Widget.
     @class
     @static
     @augments Odigeo.Events
     @param {string} name Name of the widget.
     @param {string} id ID of the widget instance.
     */
    Odigeo.Widget = function(name, id) {
        /**
         Would be dispatched once when the Widget inited
         @name Odigeo.Widget#init
         @event
         */

        /**
         Would be dispatched once when the Widget constructed
         @name Odigeo.Widget#construct
         @event
         */

        /**
         Would be dispatched after each render
         @name Odigeo.Widget#refresh
         @event
         */

        /**
         Name of the widget.
         @default 'default_name'
         @type String
         */
        this.name = name || 'default_name';

        /**
         ID of the widget.
         @default 'default_id'
         @type String
         */
        this.id = id || 'default_id';

        /**
         Flag which defines whether the widget was rendered atleast once
         @type Boolean
         */
        this.rendered = false;

        // @ignore //
        var firstRender = function() {
            this.unbind('refresh', firstRender);
            this.rendered = true;
        };

        this.bind('refresh', firstRender);

        // merging defaults with custom instance options
        var defaultOptions = this.options;
        var instanceOptions = getOptionsByID(this.id);
        this.options = _.defaults(instanceOptions, defaultOptions);
    };

    /**
     Widget template
     @type String
     @static
     */
    Odigeo.Widget.template = null;

    /**
     The URL of template that is currently being loaded
     @type String
     @private
     @static
     */
    Odigeo.Widget.templateURL = false;

    /**
     A flag that indiacates whether that template is currently being loaded
     @type Boolean
     @private
     @static
     */
    Odigeo.Widget.templateLoaded = true;

    /**
     A flag that indiacates whether that template was successfully loaded
     @type Boolean
     @private
     @static
     */
    Odigeo.Widget.templateLoading = false;

    /**
     Compiled widget template
     @type Function
     @static
     */
    Odigeo.Widget.compiledTemplate = null;

    _.extend(Odigeo.Widget.prototype, Odigeo.Events);

    _.extend(Odigeo.Widget.prototype, /** @lends Odigeo.Widget.prototype */ {
        /**
         Object containing has-map of widget options that can be different for each instance & should be set with {@link Odigeo.setOptionsByID}
         @type Object
         */
        options: {},
        /**
         Defenition of custom Model class extending {@link Odigeo.Model}
         */
        modelClass: Odigeo.Model,
        /**
         Instance of {@link Odigeo.Model} or its subclass
         @type Odigeo.Model
         */
        model: null,
        /**
         Defenition of custom View class extending {@link Odigeo.View}
         */
        viewClass: Odigeo.View,
        /**
         Instance of {@link Odigeo.View} or its subclass
         @type Odigeo.View
         */
        view: null,
        /**
         Defenition of custom Collection class extending {@link Odigeo.Collection}
         */
        collectionClass: null,
        /**
         Instance of {@link Odigeo.Collection} or its subclass
         @type Odigeo.Collection
         */
        collection: null,

        /**
         Constructs widget instance
         @private
         */
        construct: function() {
            var options = $('#' + this.id + '-options');
            if (options.length > 0) {
                try {
                    this.options = $.extend(this.options, JSON.parse(options.attr('data-value').replace(/\\'/g, '\'')));
                } catch (e) {
                    // nothing to do
                }
            }

            var $settings = $('#' + this.id + '-settings');
            if ($settings && $settings.length) {
                var parsed = JSON.parse($settings.html());
                this.options = _.extend(this.options, parsed.settings, parsed.params);
            }

            /** @ignore */
            var viewConstructed = function() {
                this.view.unbind('construct', viewConstructed);
                this.afterConstructView();

                this.init();
                this.trigger('init');

                this.trigger('construct');

                // Ilya modification.
                Odigeo.trigger(this.id + ':constructed');
            };
            /** @ignore */
            var collectionConstructed = function() {
                this.collection.unbind('construct', collectionConstructed);
                this.afterConstructCollection();

                this.view.collection = this.collection;
                this.view.afterBindCollection();
            };
            /** @ignore */
            var modelConstructed = function() {
                this.model.unbind('construct', modelConstructed);
                this.afterConstructModel();

                this.beforeConstructView();
                this.constructView();

                this.view.bind('construct', viewConstructed, this);

                this.view.construct();
            };

            this.beforeConstructModel();
            this.constructModel();

            this.model.bind('construct', modelConstructed, this);
            this.model.construct();

            if (this.collectionClass) {
                this.beforeConstructCollection();
                this.constructCollection();

                this.collection.bind('construct', collectionConstructed, this);
                this.collection.construct();
            }

            this.childWidget = [];
        },
        /**
         Set default widget values
         */
        setValue: function() {},
        /**
         run allowed widget method
         private methods access interface
         @param {string} func
         @return {Odigeo.Widget} Appropriate widget instance.
         */
        execute: function(func) {
            var args = [].slice.call(arguments, 1);
            if (_.isFunction(this[func])) {
                this[func].apply(this, args);
            }
            return this;
        },
        /**
         * Get data from widgets
         @param {string} func
         @return {*}
         */
        get: function(func) {
            var args = [].slice.call(arguments, 1);
            return this[func] ? this[func].apply(this, args) : undefined;
        },
        /**
         Returns widget selector
         @return {string} Selector string that can be used for $.find() for example.
         */
        selector: function() {
            return '[data-id=' + this.id + ']';
        },
        /**
         HOOK: override to add logic before view construction
         */
        beforeConstructView: function() {
        },
        /**
         Constructs {@link Odigeo.View} object
         @private
         */
        constructView: function() {
            if (!this.view || !(this.view instanceof Odigeo.View)) {
                var options = {el: this.selector(), model: this.model};
                if (this.viewClass) {
                    this.view = new this.viewClass(options); // eslint-disable-line new-cap
                    if (!(this.view instanceof Odigeo.View)) {
                        this.view = new Odigeo.View(options);
                    }
                } else {
                    this.view = new Odigeo.View(options);
                }
            }
            this.view.widget = this;
        },
        /**
         HOOK: override to add logic after view construction
         */
        afterConstructView: function() {
        },
        /**
         HOOK: override to add logic before model construction
         */
        beforeConstructModel: function() {
        },
        /**
         HOOK: override to add logic before model construction
         */
        beforeConstructCollection: function() {
        },
        /**
         Constructs {@link Odigeo.Model} object
         @private
         */
        constructModel: function() {
            if (!this.model || !(this.model instanceof Odigeo.Model)) {
                if (this.modelClass) {
                    this.model = new this.modelClass(); // eslint-disable-line new-cap
                    if (!(this.model instanceof Odigeo.Model)) {
                        this.model = new Odigeo.Model();
                    }
                } else {
                    this.model = new Odigeo.Model();
                }
            }
            this.model.widget = this;
        },
        /**
         Constructs {@link Odigeo.Collection} object
         @private
         */
        constructCollection: function() {
            if (this.collectionClass && (!this.collection || !(this.collection instanceof Odigeo.Collection))) {
                this.collection = new this.collectionClass(); // eslint-disable-line new-cap

                if (!(this.collection instanceof Odigeo.Collection)) {
                    this.collection = new Odigeo.Collection();
                }

                this.collection.widget = this;
            }
        },
        /**
         HOOK: override to add logic after model construction
         */
        afterConstructModel: function() {
        },
        /**
         HOOK: override to add logic after collection construction
         */
        afterConstructCollection: function() {
        },
        /**
         HOOK: override to add custom logic. Default behavior is to call {@link Odigeo.Widget#refresh}
         */
        init: function() {
            this.refresh();
        },
        /**
         Refreshes model data and then rerenders view
         @private
         */
        refresh: function() {
            /** @ignore */
            var onModelRefresh = function() {
                this.model.unbind('refresh', onModelRefresh);
                this.view.refresh();
                this.trigger('refresh');
            };

            this.model.bind('refresh', onModelRefresh, this);

            this.model.refresh();
        },
        /**
         A wrapper that allows to set some callbacks to be called after the widget was first rendered
         @param {Function} callback A callback that would be invoked right after widget's first render
         or right after method invocation if the widget has already been rendered.
         */
        ready: function(callback) {
            if (this.rendered) {
                callback();
            } else {
                /** @ignore */
                var firstRender = function() {
                    this.unbind('refresh', firstRender);
                    callback();
                };

                this.bind('refresh', firstRender, this);
            }
        },

    });

    /**
     This method allows to extend Odigeo.Widget with saving the whole prototype chain
     @function
     @static
     */
    Odigeo.Widget.extend = BB.Model.extend;

    /**
     Describes current widget definition status
     @class
     @private
     @memberOf Odigeo
     @param {string} widgetSrc Widget definition source.
     */
    var WidgetStatus = function() {
        /**
         Widget definition
         @private
         @type Odigeo.Widget
         */
        this.widgetDef = null;
        /**
         Flag that determines whether the widget definition is currently being loaded
         @private
         @type Boolean
         */
        this.loading = false;
        /**
         Flag that determines whether the widget definition has already been loaded
         @private
         @type Boolean
         */
        this.loaded = true;
        /**
         A list of callbacks to call on widget definition loading complete
         @private
         @type String[]
         */
        this.callbacks = [];
    };

    /**
     This method allows to extend Odigeo.Model with saving the whole prototype chain
     @function
     @static
     */
    Odigeo.Model = BB.Model.extend();

    _.extend(Odigeo.Model.prototype, Odigeo.Events);

    _.extend(Odigeo.Model.prototype, /** @lends Odigeo.Model.prototype */ {
        /**
         Would be dispatched once when the Widget inited
         @name Odigeo.Model#init
         @event
         */

        /**
         Would be dispatched once when the Widget constructed
         @name Odigeo.Model#construct
         @event
         */

        /**
         Would be dispatched after each data update
         @name Odigeo.Model#dataLoaded
         @event
         */

        /**
         Would be dispatched after each update
         @name Odigeo.Model#refresh
         @event
         */

        /**
         Link to the {@link Odigeo.Widget} instance
         @type Odigeo.Widget
         */
        widget: null,

        /**
         Object that contains plan data recieved from server
         @type Object
         */
        rawData: null,

        /**
         A flag that indicates whether any of attributes has been changed
         @type Boolean
         @default false
         @private
         */
        _changed: false,

        /**
         Data source URL
         @type String
         */
        urlRoot: null,
        /**
         Settings for $ AJAX data request
         @type String
         */
        dataRequestSettings: {timeout: 90000},
        /**
         Flag that determines whether the data should not be loaded at all
         @default true
         @type Boolean
         */
        isEmptyData: true,
        /**
         Flag that determines whether the data should be loaded once
         @default false
         @type Boolean
         */
        isStaticData: false,
        /**
         Flag that determines whether the data type is string (otherwise JSON)
         @default false
         @type Boolean
         */
        isStringData: false,
        /**
         Interval in milliseconds defining how often data should be retrived from the server; use '0' to turn autoUpdate off
         @default 0
         @type Number
         */
        autoUpdateInterval: 0,
        /**
         Flag that determines whether the data should be updateing (with autoUpdate) even if the widget is currentyl hidden
         @default false
         @type Boolean
         */
        updateInBackground: false,
        /**
         Flag that determines whether the data should be updated each time the widget becomes visible
         @default false
         @type Boolean
         */
        updateOnShow: false,
        /**
         Attributes which should be included in getAll returned object
         @type Array
         */
        requestAttributesSchema: null,
        /**
         Get all items of an attribute storage.
         @param {Array} schema (include filter) Array of the attributes if they match with contained in model.atributes
         that will be included in getAll returned object.
         @return {Object} attribute value.
         */
        getAll: function(schema) {
            var clonedAttributes = _.clone(this.attributes);
            if (!schema) {
                return clonedAttributes;
            } else {
                return _.pick(clonedAttributes, schema);
            }
        },
        /**
         Returns 'true' if the value valid
         @param {string} attrs
         @return {Boolean} valid data.
         */
        validate: function(attrs) {
            return _.isUndefined(attrs);
        },
        /**
         Constructs model instance
         @private
         */
        construct: function() {
            this.init();
            this.trigger('init');
            if (this.autoUpdateInterval > 0) {
                var autoUpdateFunc = _.bind(function() {
                    if ($(this.widget.selector()).is(':visible')) {
                        this.refresh();
                    } else if (this.updateInBackground) {
                        this.refresh();
                    }
                }, this);
                setInterval(autoUpdateFunc, this.autoUpdateInterval);
            }
            if (this.updateOnShow) {
                $(this.widget.selector()).bind('show', _.bind(this.refresh, this));
            }
            this.trigger('construct');
        },
        /**
         HOOK: override to add logic. Default behavior is noop
         */
        init: function() {
        },
        /**
         Refreshes data from backend if necessary
         @private
         */
        refresh: function() {
            // ignore //
            var dataLoaded = function(xhr) {
                this.unbind('dataLoaded', dataLoaded);
                this.afterLoadData(xhr);
                this.trigger('refresh');
            };

            this.bind('dataLoaded', dataLoaded);

            if (!this.isEmptyData) {
                this.beforeLoadData();
            }
            this.loadData();
        },
        save: function() {
            var BBSave = Backbone.Model.prototype.save.apply(this, arguments);
            if (!!BBSave && _.isFunction(BBSave.complete)) { // Will be false if validation returns false
                BBSave.complete(_.bind(this.afterLoadData, this));
            }
            return BBSave;
        },
        /**
         Generates data url - override if custom format is required and {@link Odigeo.Settings} has no appropriate way to handle it
         @private
         @return {string}
         */
        url: function() {
            if (!this.urlRoot) {
                if (!this.widget) {
                    throw new Error('Odigeo.Model "widget" linkage lost');
                }
                this.urlRoot = Odigeo.Settings.property('widgetUrlFormatter')(this.widget.id, this.widget.name);
            }
            return this.urlRoot;
        },
        /**
         Returns settings for $ AJAX data request or empty object is it is not set - override to add extra functionality
         @private
         @return {object}
         */
        getDataRequestSettings: function() {
            return this.dataRequestSettings || {};
        },
        /**
         HOOK: override to add logic before data load
         */
        beforeLoadData: function() {
        },
        /**
         Loads data
         @private
         */
        loadData: function() {
            if (!this.isEmptyData && (!this.rawData || !this.isStaticData || this.autoUpdate > 0)) {
                var $this = this;
                var url = this.url();

                $.ajax(_.extend(this.getDataRequestSettings(), {
                    url: url,
                    complete: function(jqXHR, textStatus) {
                        // shows that session expiration prolonged
                        Odigeo.trigger('session:refreshed');

                        if (!$this.widget) {
                            throw new Error('Odigeo.Model "widget" linkage lost');
                        }
                        if (textStatus === 'success') {
                            if ($this.isStringData) {
                                $this.rawData = jqXHR.responseText;
                            } else {
                                // $this.rawData = $.parseJSON(jqXHR.responseText);
                                $this.rawData = jqXHR.responseText;
                            }
                        } else {
                            if ($this.isStringData) {
                                $this.rawData = {};
                            } else {
                                $this.rawData = '';
                            }
                        }
                        $this.trigger('dataLoaded', jqXHR);
                    },
                }));
            } else {
                this.trigger('dataLoaded');
            }
        },
        /**
         HOOK: override to add logic after data load
         */
        afterLoadData: function() {
        },

    }, {});

    /**
     This method allows to extend Odigeo.Model with saving the whole prototype chain
     @function
     @static
     */
    Odigeo.Model.extend = BB.Model.extend;

    var DUMMY_TEMPLATE = _.template('');
    /** @namespace Odigeo.View */
    Odigeo.View = BB.View.extend({
        /**
         Would be dispatched once when the Widget inited
         @name Odigeo.View#init
         @event
         */

        /**
         Would be dispatched once when the Widget constructed
         @name Odigeo.View#construct
         @event
         */

        /**
         Would be dispatched once, when template is ready for use
         @name Odigeo.View#templateLoaded
         @event
         */

        /**
         Would be dispatched after each render
         @name Odigeo.View#refresh
         @event
         */

        /**
         Link to the {@link Odigeo.Widget} instance
         @type Odigeo.Widget
         */
        widget: null,
        /**
         Selector to widget main div
         @type $ object
         */
        $widget: null,
        /**
         Flag that determines whether the Model update should be ignored by the View (in this case you may launch {@link Odigeo.View#refresh} manualy)
         @default true
         @type Boolean
         */
        ignoreModelUpdate: true,
        /**
         Flag that determines whether the view should be rerendered each time the widget becomes visible
         @default false
         @type Boolean
         */
        updateOnShow: false,
        /**
         Flag that determines is the widget binded to DOM
         @default false
         @type Boolean
         */
        isDomBinded: false,
        /**
         JQ DOM selectors cache
         @default null
         @type Object
         */
        $cachedSelectors: null,
        /**
         * Widget templates
         @default {}
         @type Object
         */
        templates: {},
        /**
         * Return the template builder according to the templateName
         * @param {String} templateName - The template name
         * @return {object}
         */
        getTemplateBuilder: function(templateName) {
            return this.templates[templateName];
        },
        /**
         * Return the template builder according to the templateName
         * @param {String} template The static template name e.g. nag
         * @param {String}  templateName the template name e.g. default
         * @return {string|undefined}
         */
        getStaticTemplateBuilder: function(template, templateName) {
            return _.isObject(this.staticTemplates[template]) ?
                this.staticTemplates[template][templateName] :
                undefined;
        },
        /**
         * Callback that can be used to modify or adding additional parsed data before insert the template in the parent one
         * @param  {Object} data The data for the template
         * @return {Object}
         */
        beforeInsertTemplate: function(data) {
            return data;
        },
        /**
         * setTemplate Function for setting templates (only in Widget templates)
         * @param {jQuery} $selector Where we are going to add the template
         * @param {String} tmplName The template that we want to add
         * @param {Object} data The data for the template
         */
        setTemplate: function($selector, tmplName, data) {
            data = _.isObject(data) ? data : {};
            var insertTemplate = function(tmplName, data) {
                var tmpl = this.getTemplateBuilder(tmplName) || DUMMY_TEMPLATE;
                var parsedData = this.beforeInsertTemplate(data);
                return tmpl ? tmpl(_.extend(parsedData, {
                    insertTemplate: _.bind(insertTemplate, this),
                    keys: this.keys,
                    pluralizeAll: Odigeo.Utils.pluralizeAll,
                    replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
                })) : '';
            };

            $selector.html(insertTemplate.call(this, tmplName, data));
            this.updateDomSelectorsToCache();
            this.bindViewEvents();
        },

        /**
         * getParsedTemplateContent Function for getting template parsed content (only in Widget templates)
         * @param {String} tmplName The template that we want to add
         * @param {Object} [data={}] The data for the template
         * @return {string} the compiled template string
         */
        getParsedTemplateContent: function(tmplName, data) {
            var tmpl = this.getTemplateBuilder(tmplName) || DUMMY_TEMPLATE;
            var parsedData = this.beforeInsertTemplate(data) || {};

            return tmpl ? tmpl(_.extend({}, parsedData, {
                insertTemplate: _.bind(this.getParsedTemplateContent, this),
                keys: this.keys,
                pluralizeAll: Odigeo.Utils.pluralizeAll,
                replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
                options: Odigeo.parseOptions(this.widget.options),
            })) : '';
        },
        /**
         Constructs view instance
         @private
         */
        construct: function() {
            if (Odigeo.Templates && Odigeo.Templates.isTemplatesLoaded(this.widget.name)) {
                Odigeo.Templates.getWidgetTemplate(this.widget.name).done(_.bind(function(widget) {
                    this.templates = widget.templates;
                    this.keys = widget.keys;

                    var finishLoading = _.bind(function() {
                        if (this.templates.main) {
                            this.$el.append(this.templates.main);
                        }
                        this.updateDomSelectorsToCache();
                        this.bindViewEvents();
                    }, this);

                    if (!_.isEmpty(this.widget.options.staticTemplates)) {
                        var staticsTemplatesList = _.isArray(this.widget.options.staticTemplates) ?
                            this.widget.options.staticTemplates :
                            [this.widget.options.staticTemplates];

                        Odigeo.Templates.getGenericTemplates(staticsTemplatesList)
                            .done(_.bind(function(templates) {
                                this.staticTemplates = templates;
                                finishLoading();
                            }, this));
                    } else {
                        finishLoading();
                    }
                }, this));
            }

            this.init();
            this.trigger('init');

            if (!this.ignoreModelUpdate) {
                this.widget.model.bind('change', this.refresh, this);
            }
            this.trigger('construct');
        },
        /**
         HOOK: override to add custom logic on init
         */
        init: function() {},
        initialize: function(options) {
            this.$el = this.$widget = $(options.el);
            this.el = this.$el[0];

            this.templates = {};
            this.keys = {};

            this.staticTemplates = {};

            this.bindViewEvents();
            this.addDomSelectorsToCache();
        },
        /**
         Renders widget into placeholder + calling all the necessary hooks & events
         */
        refresh: function() {
            this.preRender();
            this.render();
            this.postRender();
            this.trigger('refresh');
        },
        /**
         HOOK: override to add logic before render
         */
        preRender: function() {},
        /**
         HOOK: override to add logic after render
         */
        postRender: function() {},
        /**
         Add DOM $ selectors into internal widget attribute $cachedSelectors
         @param {string} cachedName - name of the cached selector, you can access
         to selector using it i.e. <code>this.$cahedSelectors['cachedName']</code>
         @param {$} selector - DOM $ selector. i.e. <code>this.$widget.find('input')</code>.
         @return {boolean|undefined}
         */
        addSelectorToCache: function(cachedName, selector) {
            var $cachedSelectors = {};

            if (this.$cachedSelectors) {
                $cachedSelectors = this.$cachedSelectors;
            }

            if ($cachedSelectors[cachedName]) {
                return false;
            }

            $cachedSelectors[cachedName] = selector;
            this.$cachedSelectors = $cachedSelectors;
        },
        /**
         Remove DOM $ selectors from internal widget cache $cachedSelectors
         @param {string} cachedName - name of the cached selector.
         @return {boolean|undefined}
         */
        removeSelectorFromCache: function(cachedName) {
            if (!this.$cachedSelectors) {
                return false;
            }

            var $cachedSelectors = this.$cachedSelectors;

            if (!$cachedSelectors[cachedName]) {
                return false;
            }

            delete $cachedSelectors[cachedName];
        },
        /**
         * @deprecated use {@link http://backbonejs.org/#View-delegateEvents|delegateEvents} mechanism instead
         */
        cacheDomSelectors: function() {},
        /**
         * @deprecated use {@link http://backbonejs.org/#View-delegateEvents|delegateEvents} mechanism instead
         */
        bindToDom: function() {},
        /**
         * @deprecated use {@link http://backbonejs.org/#View-undelegateEvents|undelegateEvents} mechanism instead

         */
        unbindFromDom: function() {},

        addDomSelectorsToCache: function() {
            _.each(this.selectors, (sel, key) => {
                this.addSelectorToCache(key, this.$widget.find(sel));
            });
        },

        updateDomSelectorsToCache: function() {
            _.each(this.selectors, (sel, key) => {
                this.removeSelectorFromCache(key);
                this.addSelectorToCache(key, this.$widget.find(sel));
            });
        },

        bindViewEvents: function() {
            var selectors = this.selectors || false;
            _.each(this.events, function(value, key, list) {
                var match = key.match(/^(\S+)\s*(.*)$/);
                var eventName = match[1];
                var selector = match[2];

                if (selector.charAt(0) === '@' && selectors) {
                    selector = selectors[selector.slice(1)];
                }

                if (Odigeo.Events.hasOwnProperty(eventName)) {
                    delete list[key];
                    var eventsArray = Odigeo.Events[eventName].trim().split(' ');
                    _.each(eventsArray, function(event) {
                        list[event + ' ' + selector] = value;
                    });
                } else {
                    list[key] = value;
                }
            });
        },
    });

    /**
     Implements a view for one Collection.
     @class
     @static
     */
    Odigeo.CollectionView = Odigeo.View.extend({
        childViewClass: Odigeo.View,
        _selectors: {
            childViewContainer: '.child_view_container',
        },

        initialize: function() {
            this._childViews = [];
            return Odigeo.View.prototype.initialize.apply(this, arguments);
        },

        childsLength: function() {
            return this._childViews.length;
        },

        afterBindCollection: function() {
            this.listenTo(this.collection, 'add', this.addChild);
            this.listenTo(this.collection, 'remove', this.destroyChildren);

            return this;
        },

        getIndex: function(reference) {
            if (reference instanceof BB.Model) {
                return this.collection.indexOf(reference);
            }

            return this.indexOf(reference);
        },

        addChild: function(model) {
            this.addChildView(this.childViewClass, this.childViewOptions(model), model);
        },

        addChildView: function(ChildViewClass, childViewOptions, model) {
            var childView = new ChildViewClass(childViewOptions);
            var index = this.collection.indexOf(model);

            childView.collectionView = this;
            this._childViews[index] = childView;
            this.trigger('before:add:child', childView);
            this.renderChildView(childView);
            this.trigger('add:child', childView);

            return this;
        },

        renderChildView: function(childView) {
            this.$(this._selectors.childViewContainer).append(childView.render().$el);

            return this;
        },

        getChildView: function(reference) {
            var index = reference instanceof BB.Model ? this.collection.indexOf(reference) : reference;

            return this._childViews[index] instanceof BB.View ?
                this._childViews[index] : false;
        },

        getNextChildView: function(reference) {
            var index = this.getIndex(reference);

            if (index < 0 || index >= this._childViews.length) {
                return false;
            }

            return this._childViews[++index];
        },

        getPrevChildView: function(reference) {
            var index = this.getIndex(reference);

            if (index <= 0) {
                return false;
            }

            return this._childViews[--index];
        },

        childViewOptions: function(model) {
            return {
                model: model,
            };
        },

        destroyChildren: function(model, collection, options) {
            if (this._childViews[options.index] instanceof BB.View) {
                this.stopListening(model);
                this.stopListening(this._childViews[options.index]);
                this._childViews[options.index].remove();
                this._childViews.splice(options.index, 1);
            }

            return this;
        },
    });

    /**
    List of Underscore methods.
    */
    var methods = ['forEach', 'each', 'map', 'find', 'filter', 'every', 'all', 'some', 'any', 'contains',
        'first', 'last', 'without', 'indexOf', 'lastIndexOf'];

    /**
    Mix in each Underscore method as a proxy to `CollectionView#subViews`.
    */
    _.each(methods, function(method) {
        Odigeo.CollectionView.prototype[method] = function() {
            var args = [].slice.call(arguments);
            args.unshift(this._childViews);
            return _[method].apply(_, args);
        };
    });

    var safeCallBackExecute = function(obj, cb, context) {
        if (_.isObject(obj) && _.isFunction(cb)) {
            _.bind(cb, context)(obj);
        }
    };

    /**
     This method allows to extend Odigeo.Collection with saving the whole prototype chain
     @function
     @static
     */

    Odigeo.Collection = BB.Collection.extend({
        /**
         Constructs model instance
         @private
         */
        construct: function() {
            this.init();
            this.trigger('init');
            this.trigger('construct');
        },
        /**
         HOOK: override to add logic. Default behavior is noop
         */
        init: function() {},
        /**
         If collection.at(index) returs a model, execute a callback with model as argument
         @public
         @param {number} index
         @param {function} cb
         @param {Object} context
         @return {this}
         */
        safeAt: function(index, cb, context) {
            var model = this.at(index);
            safeCallBackExecute(model, cb, context || this);

            return this;
        },

        /**
         If collection.get(id) returs a model, execute a callback with model as argument
         @public
         @param {number} id
         @param {function} cb
         @param {Object} context
         @return {this}
         */
        safeGet: function(id, cb, context) {
            var model = this.get(id);
            safeCallBackExecute(model, cb, context || this);

            return this;
        },
    });

    /**
     Instance of {@link Odigeo.RootWidget}
     @static
     @private
     @type {Odigeo.RootWidget}
     */
    Odigeo.RootComponentInstance = null;

    /**
     Root Component.
     @class
     @static
     @augments Odigeo.Widget
     */
    Odigeo.RootComponent = Odigeo.Widget.extend(/** @lends Odigeo.RootComponent.prototype */ {
        /**
         HOOK: override to add logic before starting routing
         */
        beforeStart: function() {
        },
        /**
         Launches Routing & automated ViewSwitcher
         @private
         */
        start: function() {
            Odigeo.Router.start();
            Odigeo.ViewSwitcher.start();
        },
        /**
         HOOK: override to add logic after starting routing
         */
        afterStart: function() {
        },
        /**
         Overrides {@link Odigeo.Widget} constructor in order to add Routing start call
         @param {string} name Name of the widget.
         @param {string} id ID of the widget instance.
         @private
         */
        constructor: function() {
            if (Odigeo.RootComponentInstance) {
                throw new Error('Odigeo.RootComponent can be only ONE!');
            }
            Odigeo.RootComponentInstance = this;

            this.ready(function() {
                Odigeo.RootComponentInstance.beforeStart();
                Odigeo.RootComponentInstance.start();
                Odigeo.RootComponentInstance.afterStart();
            });

            Odigeo.Widget.apply(this, arguments);
        },
    });

    /**
     * Options to extend view controller in router
     */
    Odigeo.viewControllerCustomOptions = {};

    /**
     Used to switch between views
     @static
     @private
     @type {Object}
     */
    Odigeo.ViewSwitcher = {};

    _.extend(Odigeo.ViewSwitcher, /** @lends Odigeo.ViewSwitcher */ {
        /**
         CSS class used to identify views
         @type String
         @default 'od_page'
         */
        viewClass: 'od_page',
        /**
         CSS class used to identify active view
         @type String
         @default 'active'
         */
        activeViewClass: 'active',
        /**
         Animation type for view switching ('fade')
         @type String
         @default 'fade'
         */
        animationName: 'fade',
        /**
         CSS class used to to add to viewport while page switching is running
         @type String
         @default 'od-viewport-transitioning'
         */
        viewportTransitioningClass: 'od-viewport-transitioning',
        /**
         Saves current active view
         @type $
         @private
         */
        activePage: null,
        /**
         Animation duration for page switching
         @type Number
         @default 250
         */
        animationDuration: 280,
        /**
         Animation timing function for page switching. See jQuery or zepto docs for correct types
         @type String
         @default 'linear'
         */
        easing: 'swing',
        /**
         Initialises ViewSwitcher: get current active view and binds necessary routes handling
         @private
         */
        start: function() {
            // Save app params from HTML
            var isHttpsPermitted = $('#page').data('is-https-permitted');
            Odigeo.PageStorage.set('isHttpsPermitted', isHttpsPermitted);

            storageUtils.removeFromStorage('Storage', 'paymentData');
            storageUtils.setOFHomeVersionInLocalStorage();
            storageUtils.setOFHomeVersionInSessionStorage();

            var pages = $(Odigeo.RootComponentInstance.selector() + ' .' + this.viewClass);
            var currentPage = Odigeo.History.getPageNameFromFragment();
            Odigeo.Router.bindAnyRoute(this.routeHandler);

            if (pages.length) {
                var preselectedAP = pages.filter('.' + this.activeViewClass);
                if (preselectedAP.length) {
                    this.activePage = preselectedAP;
                } else if (!_.isEmpty(currentPage) && currentPage.length) {
                    this.switchToView(currentPage);
                } else {
                    this.switchToView(pages.first());
                }
            }
        },
        /**
         * Handles every Odigeo.Router 'route:*' event and invokes view switching if necessary
         @param {string} eventName
         @private
         */
        routeHandler: function(eventName) {
            var routeName = Odigeo.Router.getRouteByEventName(eventName);
            var jqPage = $('.' + Odigeo.ViewSwitcher.viewClass + '#' + routeName);

            if (jqPage.length) {
                Odigeo.ViewSwitcher.switchToView(jqPage);
            }
        },
        /**
         Executes animation sequence for switching
         @param {$} jqPage
         */
        switchToView: function(jqPage) {
            var switcher = this;
            var $fromPage = this.activePage;
            var $toPage = jqPage;
            var viewport = Odigeo.Device.getViewport();
            var switchToViewDeferred = $.Deferred();
            Odigeo.trigger('page:beforeSwitch', $toPage, $fromPage);

            switchToViewDeferred
                .done(function() {
                    if ($fromPage) {
                        viewport.addClass('od-viewport-transitioning');
                    }
                })
                .done(function() {
                    if ($fromPage) {
                        $fromPage.css({
                            'display': 'none',
                        }).removeClass(switcher.activeViewClass);
                    }

                    window.scrollTo(0, 0);
                    $toPage.addClass(switcher.activeViewClass).css({
                        'opacity': 0,
                        'display': 'block',
                    });
                })
                .done(function() {
                    $toPage.attr('style', '');
                    if ($fromPage) {
                        viewport.removeClass('od-viewport-transitioning');
                    }

                    switcher.activePage = $toPage;
                    Odigeo.trigger('page:afterSwitch', $toPage, $fromPage);

                    switcher.viewController.call(switcher.activePage[0]);
                    // looking for widgets inside the page
                    loadChildWidgets(switcher.activePage[0]);
                    Odigeo.trigger('checkLazyImages');
                });
            switchToViewDeferred.resolve();
        },
        // TODO remove from here ---->
        /** @ignore */
        viewController: function(/* options*/) {
            var completedWidgetsList;
            var controllableWidgetsAmount;
            var completedAmount;

            if (!this.isLoaded) {
                // attributes object
                this.attr = {
                    // flag to load data once
                    isLoaded: true,
                    // flag to determin whether we reload all page or just refresh current view
                    isPageReloaded: false,
                    // flag to determine when all widgets are completed successfuly
                    allWidgetsCompleted: false,
                };
                // object for data collection
                this.data = {};
                // schema for collecting data on a page
                this.resultSchema = {};
                // list of all widget ids on a page
                this.childrenWidgets = [];
                // list of controllable widget ids
                this.controllableWidgets = [];
                // id of the current page
                this.pageName = $(this).attr('id');

                /* private variables */
                completedAmount = 0;
                completedWidgetsList = [];
                controllableWidgetsAmount = 0;

                /**
                 * Find all 'required' widgets in a page
                 * @private
                 */
                this.getChildren = function() {
                    var children;
                    var self = this;

                    self.controllableWidgets = [];
                    children = $(this).find('[data-controllable]');
                    _.each(children, function(el) {
                        self.controllableWidgets.push($(el).attr('id'));
                    });
                    _.each($(this).find('[data-widget]'), function(el) {
                        self.childrenWidgets.push($(el).attr('id'));
                    });
                    controllableWidgetsAmount = this.controllableWidgets.length;
                };

                /**
                 * Handler for complete event
                 * @param {object} data
                 */
                this.widgetCompleteHandler = function(data) {
                    var index;
                    var widgetID = data.id;

                    index = _.indexOf(completedWidgetsList, widgetID);
                    if (data.type === 'success') {
                        if (index === -1) {
                            completedAmount++;
                            completedWidgetsList.push(widgetID);
                        }

                        if (this.widgetSuccessHandler) {
                            this.widgetSuccessHandler.call(this, widgetID, data.data, data);
                        }

                        if (controllableWidgetsAmount === completedAmount) {
                            this.attr.allWidgetsCompleted = true;
                            if (this.allWidgetsCompleteHandler) {
                                this.allWidgetsCompleteHandler.call(this);
                            }
                        }
                    } else {
                        if (index !== -1) {
                            completedAmount--;
                            completedWidgetsList.splice(index, 1);
                        }

                        this.attr.allWidgetsCompleted = false;
                        if (this.widgetErrorHandler) {
                            this.widgetErrorHandler.call(this, widgetID);
                        }
                    }
                };

                this.isAllWidgetsComplete = function() {
                    return controllableWidgetsAmount === completedAmount;
                };

                /**
                 * bind events to widgets
                 */
                this.bindWidgets = function() {
                    var self = this;

                    _.each(this.controllableWidgets, function(child) {
                        Odigeo.bind('complete:' + child, _.bind(self.widgetCompleteHandler, self));
                    });
                    _.each(this.childrenWidgets, function(child) {
                        // custom bindings
                        for (var key in self.bindings) {
                            if (self.bindings.hasOwnProperty(key)) {
                                Odigeo.bind(key + ':' + child, _.bind(self.bindings[key], self));
                            }
                        }
                    });
                };

                /**
                 * unbind events
                 */
                this.unbindWidgets = function() {
                    var self = this;
                    var unbindElements = function(bindings, unbindChild) {
                        for (var key in bindings) {
                            if (bindings.hasOwnProperty(key)) {
                                Odigeo.unbind(key + ':' + unbindChild);
                            }
                        }
                    };
                    _.each(this.controllableWidgets, function(child) {
                        Odigeo.unbind('complete:' + child);
                        unbindElements(self.bindings, child);
                    });

                    _.each(this.childrenWidgets, function(child) {
                        unbindElements(self.bindings, child);
                    });
                };

                /**
                 * Controller initialization for the first time
                 */
                this.construct = function() {
                    if (this.beforeInitPage) {
                        this.beforeInitPage();
                    }

                    if (Odigeo.viewControllerCustomOptions[this.pageName]) {
                        this.resultSchema = Odigeo.viewControllerCustomOptions[this.pageName].resultSchema || {};
                    } else {
                        this.resultSchema = {};
                    }

                    // clear children array
                    this.childrenWidgets = [];
                    loadChildWidgets(this);
                    this.getChildren();
                    this.unbindWidgets();
                    this.bindWidgets();
                    if (this.init) {
                        this.init();
                    }
                    this.isPageReloaded = false;
                };

                /**
                 * refresh widget view
                 */
                this.refresh = function() {
                    if (!this.isPageReloaded) {
                        this.unbindWidgets();
                        this.bindWidgets();
                        _.each(this.childrenWidgets, function(widgetID) {
                            Odigeo.trigger('refreshView:' + widgetID);
                        });
                        if (this.rerender) {
                            this.rerender();
                        }
                    }
                    if (Odigeo.viewControllerCustomOptions[this.pageName]) {
                        this.resultSchema = Odigeo.viewControllerCustomOptions[this.pageName].resultSchema || {};
                    } else {
                        this.resultSchema = {};
                    }
                };

                /**
                 * load widgets content
                 */
                this.loadPage = function() {
                    var self = this;
                    var $mainWidget;

                    $mainWidget = $(this).find('[data-page]');
                    loadWidget($mainWidget.data('id'), $mainWidget.data('name'), _.bind(self.construct, self));
                };

                this.beforePageLoad = function() {
                    this.isPageReloaded = true;
                    if (this.beforePageReloadCallback) {
                        this.beforePageReloadCallback();
                    }
                };

                this.pageDirectlyLoaded = function() {
                };
                this.pageHashLoaded = function() {
                };

                _.extend(this, Odigeo.viewControllerCustomOptions[this.pageName]);

                var $this = this;

                // Todo: i don't find the use of this loadWidgets. Remove after refactor
                Odigeo.bind('loadWidgets:' + this.id, _.bind(this.loadPage, this));
                Odigeo.bind('reloadPage:' + this.id, _.bind(this.beforePageLoad, this));
                Odigeo.bind('pageshow', function() {
                    Odigeo.trigger('pageshow:' + $this.id);
                });
                this.beforePageLoad();
                this.isLoaded = true;
                if (!Odigeo.PageStorage.get('page')) {
                    this.pageDirectlyLoaded();
                } else {
                    this.pageHashLoaded();
                }
            } else {
                this.refresh();
            }
        },
        // TODO <---- remove to here
    });

    bowser.parsedVersion = parseInt(_.get(bowser, 'version', '').split('.')[0]);
    bowser.parsedOsVersion = parseInt(_.get(bowser, 'osversion', '').split('.')[0]);
    /**
     Contains device specific information
     @static
     @private
     @type {Odigeo.DeviceClass}
    */
    Odigeo.Device = {
        /**
         Contains device viewport size: {width; height}
         @type Object
         */
        viewport: {
            width: $(window).width(),
            height: $(window).height(),
        },
        isTablet: function() {
            return bowser.tablet || false;
        },
        /**
         * @namespace Navigator features
         */
        navigator: {
            /**
             Is device navigator an iOS
             @type boolean
             */
            isIOS: bowser.ios || false,
            /**
             Is device navigator an iOS version 7 or higher
             @type boolean
             */
            isIOS7: (bowser.ios && bowser.parsedOsVersion === 7) || false,
            /**
             Is device navigator an iOS version 8 or higher
             @type boolean
             */
            isIOS8: (bowser.ios && bowser.parsedOsVersion === 8) || false,
            /**
             Is device navigator an iOS version 9 or higher
             @type boolean
             */
            isIOS9: (bowser.ios && bowser.parsedOsVersion === 9) || false,
            /**
             Is device navigator an iOS version 10 or higher
             @type boolean
             */
            isIOS10: (bowser.ios && bowser.parsedOsVersion === 10) || false,
            /**
             Is device navigator an iOS version 11 or higher
             @type boolean
             */
            isIOS11: (bowser.ios && bowser.parsedOsVersion === 11) || false,
            /**
             Is device navigator an iOS version 12 or higher
             @type boolean
             */
            isIOS12: (bowser.ios && bowser.parsedOsVersion === 12) || false,
            /**
             Is device navigator a Google Chrome on iOS
             @type boolean
             */
            isCriOS: (bowser.ios && bowser.chrome) || false,
            /**
             Is device navigator a Safari on iOS
             @type boolean
             */
            isSafariiOS: (bowser.ios && bowser.safari) || false,
            /**
             Is device navigator a Mozilla Firefox
             @type boolean
             */
            isFirefox: bowser.firefox || false,
            /**
             Is device navigator a Chrome
             @type boolean
             */
            isChrome: bowser.chrome || false,
            /**
             Is device navigator an Opera
             @type boolean
             */
            isOpera: bowser.opera || false,
            /**
             Is device navigator an Android
             @type boolean
             */
            isAndroid: bowser.android || false,
            /**
             Is device navigator at least Android ICS (version >= 4)
             @type boolean
             */
            isAndroidICS: (bowser.android && bowser.parsedOsVersion >= 4) || false,
            /**
             Is device navigator an Internet Explorer
             @type boolean
             */
            isIE: bowser.msie || false,
            /**
             Is device navigator an Internet Explorer
             @type boolean
             */
            isIE9: (bowser.msie && bowser.parsedVersion === 9) || false,
            /**
             Is device navigator a Edge
             */
            isEdge: bowser.msedge || false,
            /**
             Is device navigator an WindowsPhone
             @type boolean
             */
            isWinPhone: bowser.windowsphone || false,
            /**
             Is device navigator a Safari
             */
            isSafari: bowser.safari || false,
            /**
             Is device navigator a WebView in iOS
             @type boolean
             */
            isIOSWebView: (/.*(iPad|iPhone).*Mobile\/[0-9A-Z]+$/i.
                test((navigator.userAgent || navigator.vendor || window.opera).toLowerCase())),
            /**
             Is device navigator a WebView in Android
             @type boolean
             */
            isAndroidWebView: (/.*Android( 4\.4.*Version.*Chrome.*Mobile.*|.* wv\) ).*/i.
                test((navigator.userAgent || navigator.vendor || window.opera).toLowerCase())),
            /**
             Is native interface
             @type boolean
             */
            /**
             * Function to detect if OneFront is running on native app
             * @return {boolean}
             */
            isNative: function() {
                return this.isIOSWebView || this.isAndroidWebView;
            },
            /**
             device navigator has cookies and are enabled. Pollyfills browsers with no support of navigator.cookieEnabled
             @type boolean
             */
            hasCookies: navigator.cookieEnabled ||
                ('cookie' in document && (document.cookie.length > 0 ||
                    (document.cookie = 'test').indexOf.call(document.cookie, 'test') > -1)),
            /**
             If device navigator supports an input of a certain type [date|month]
             @type boolean
             */

            supportsInput: function(type) {
                var el = document.createElement('input');
                var notADateValue = 'not-a-date';
                el.setAttribute('type', type);
                el.setAttribute('value', notADateValue);
                return (el.value !== notADateValue);
            },

            // Handle specific behaviors for touchable devices
            isTouchable: isTouchable,
        },
        location: {
            /**
             Tries to retrieve the location of the device, returning a promise that resolves with the location,
             or fails.
             @return {promise}
             */
            get: function() {
                var dfd = $.Deferred();
                var timer;

                if ('geolocation' in navigator) {
                    // Firefox doesn't throw error when user press 'Not share' geolocation
                    if (Odigeo.Device.navigator.isFirefox) {
                        timer = setTimeout(function() {
                            // Timed out
                            dfd.reject(false);
                        }, 15000);
                    }

                    navigator.geolocation.getCurrentPosition(function(position) {
                        // Clear timer
                        if (timer) {
                            clearTimeout(timer);
                        }
                        dfd.resolve(position);
                    }, function(reason) {
                        dfd.reject(reason);
                    }, {
                        timeout: 10000,
                        enableHighAccuracy: false,
                    });
                } else {
                    // Geolocation not supported
                    dfd.reject(false);
                }

                return dfd.promise();
            },
        },
    };
    _.extend(Odigeo.Device, /** @lends Odigeo.DeviceClass.prototype */ {
        /**
         Returns current screen height
         @return {Number}
         */
        getScreenHeight: function() {
            return $(window).outerHeight();
        },

        /**
         Returns viewport $ object
         @return {jquery}
         */
        getViewport: function() {
            // if there's no explicit viewport make body the viewport
            var vp = $('body').addClass('od-viewport');
            if (!vp[0]) {
                vp = $('.od_page').eq(0);
                if (!vp.length) {
                    vp = $('body');
                } else {
                    vp = vp.parent();
                }
                vp.addClass('od-viewport');
            }
            return vp.eq(0);
        },
    });

    /**
     * A convenience function for parsing string namespaces and automatically generating nested namespaces
     * @param {string} ns Parent namespace
     * @param {string} nsString full namespace to extend
     * @return {string|Object}
     */
    var extendNamespace = function(ns, nsString) {
        var parts = nsString.split('.');
        var nsp = ns || {};
        var parent = nsp;
        var pl;

        pl = parts.length;

        for (var i = 0; i < pl; i++) {
            // create a property if it doesn't exist
            if (typeof parent[parts[i]] === 'undefined') {
                parent[parts[i]] = {};
            }

            parent = parent[parts[i]];
        }

        return nsp;
    };

    /**
     * @see {extendNamespace}
     */
    Odigeo.extendNamespace = extendNamespace;

    _.extend(Odigeo, Odigeo.Events);

    window.Odigeo = Odigeo;
    /**
     * Checks if elements with class lazy are visible and then removes this class.
     * Inspired by {@link http://luis-almeida.github.com/unveil}
     */
    var checkLazyImages = function() {
        $('.lazy', '.od_page.active, #page').filter(function() {
            var $e = $(this);
            if ($e.is(':hidden')) {
                return false;
            }
            return Odigeo.Utils.elementInViewport($e);
        }).removeClass('lazy');
    };

    // $ hooks //
    var _oldhide = $.fn.hide;
    var _oldshow = $.fn.show;
    var _oldhtml = $.fn.html;
    var _oldappend = $.fn.append;
    var _oldprepend = $.fn.prepend;
    var _olddetach = $.fn.detach;

    // @ignore //
    $.fn.hide = function() {
        var res = _oldhide.apply(this, arguments);
        $(this).trigger('hide');
        return res;
    };

    // @ignore //
    $.fn.show = function() {
        var res = _oldshow.apply(this, arguments);
        $(this).trigger('show');
        return res;
    };

    // @ignore //
    $.fn.html = function() {
        var res = _oldhtml.apply(this, arguments);
        $(this).trigger('show');
        $(this).trigger('html');
        return res;
    };

    // @ignore //
    $.fn.append = function() {
        var res = _oldappend.apply(this, arguments);
        $(this).trigger('append');
        return res;
    };

    // @ignore //
    $.fn.prepend = function() {
        var res = _oldprepend.apply(this, arguments);
        $(this).trigger('prepend');
        return res;
    };

    if (!_.isFunction($.fn.detach)) {
        $.fn.detach = function(a) {
            return this.remove(a, !0);
        };
    }

    if (!_.isFunction($.fn.wrapInner)) {
        $.fn.wrapInner = function(html) {
            if (_.isFunction(html)) {
                return this.each(function(i) {
                    $(this).wrapInner(html.call(this, i));
                });
            }

            return this.each(function() {
                var self = $(this);
                var contents = self.contents();

                if (contents.length) {
                    contents.wrapAll(html);
                } else {
                    self.append(html);
                }
            });
        };
    }

    // @ignore //
    $.fn.detach = function() {
        var parent = $(this).parent();
        var res = _olddetach.apply(this, arguments);
        parent.trigger('detach');
        return res;
    };

    // @ignore //
    // Cannot use $.fn.extend because of Zepto support //
    if (!_.isFunction($.fn.outerHtml)) {
        $.fn.outerHtml = function(replacement) {
            if (replacement) {
                return this.each(function() {
                    $(this).replaceWith(replacement);
                });
            }

            var tmpNode = $('<div>').append($(this).clone());
            var markup = tmpNode.html();

            tmpNode.remove();
            return markup;
        };
    }

    if (!_.isFunction($.fn.outerWidth)) {
        _.each(['width', 'height'], function(dimension) {
            var Dimension = dimension.replace(/./, function(m) {
                return m[0].toUpperCase();
            });
            $.fn['outer' + Dimension] = function(margin) {
                var elem = this;
                var size = elem[dimension]();
                var sides = {
                    'width': ['left', 'right'],
                    'height': ['top', 'bottom'],
                };
                if (elem) {
                    _.each(sides[dimension], function(side) {
                        if (margin) {
                            size += parseInt(elem.css('margin-' + side), 10);
                        }
                    });
                    return size;
                } else {
                    return null;
                }
            };
        });
    }
}).call(this, window, window.$, window.Backbone, 'cbOdigeoLoaded', window.bowser);
